import gql from 'graphql-tag'

export const GET_AUTH = gql`
  query auth($login: String!, $password: String!) {
    auth(login: $login, password: $password) {
      sid id fullName companyId companyTitle
    }
  }
`
export const GET_USER_INFO = gql`
  query userInfo {
    userInfo{
      id fullName companyId companyTitle
    }
  }
`
